<template>
  <div class="h-[114px] flex flex-col justify-between w-full z-4">
    <div class="flex flex-row justify-between items-center mt-7 max-w-[1300px] w-full mx-auto">
      <div class="flex justify-center items-center space-x-6">
        <OImage loading="lazy" src="/images/game/oyunLogo.png" class="w-[173px] h-[68px] justify-start" />
        <OBreadcrumb
          class="capitalize text-md leading-18 mt-6 mb-4 overflow-x-auto"
          :items="breadcrumbRoutes"
          show-home-page-title
          style="color: white"
        />
      </div>
      <div class="flex max-w-[350px] h-[45px] w-full">
        <UserLeaderboardInfoHeader :current-tab="currentTab" type="skor" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, useRoute, computed } from '@nuxtjs/composition-api';
import { OBreadcrumb, OImage } from '@/modules/common/components/ui';
import UserLeaderboardInfoHeader from '../leaderboard/UserLeaderboardInfoHeader.vue';
import { IS_ONEDIO } from '~/constants/config';

export default defineComponent({
  components: { OBreadcrumb, UserLeaderboardInfoHeader, OImage },
  props: {
    currentTab: {
      required: true,
      type: String,
    },
  },
  setup(props) {
    const route = useRoute();
    const breadcrumbRoutes = computed(() => {
      return [
        { href: `/${props.currentTab}`, name: props.currentTab },
        { href: route.value.fullPath, name: 'Geçmiş Tarihli Oyunlar' },
      ];
    });
    return { IS_ONEDIO, breadcrumbRoutes };
  },
});
</script>
